import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { ReactComponent as CommentIcon } from 'icons/comment-12.svg'

const Amount = styled.span`
  margin-right: 4px;
`

const StyledSpeechBalloonIcon = styled(CommentIcon)`
  width: 12px;
  height: 12px;
`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const UnreadIndicator = styled(({ amount, highlight, ...props }) => (
  <span {...props}>
    {amount && <Amount>{amount}</Amount>}
    <StyledSpeechBalloonIcon />
  </span>
))`
  display: flex;
  align-items: center;

  color: ${({ theme, highlight }) =>
    highlight ? theme.colors.primary : theme.colors.text.dark.tertiary};
`

UnreadIndicator.defaultProps = {
  highlight: false,
}

UnreadIndicator.propTypes = {
  amount: PropTypes.number,
  highlight: PropTypes.bool,
}

export default UnreadIndicator
